<template>
<div class="associate-cohort-leaps-challenge">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-2Perc margin-top-2Perc cursor-pointer" v-on:click="closeCurrentOverlay()">
                    <img src= "../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Group:
                </div>
                <div class="col-md-4 col-lg-4 text-align-left">
                  <div class="form-group margin-bottom-0Perc">
                    <select class="form-control" v-model="getSelectedGroupObj" :disabled="disableGroupDropDown">
                      <option value='-1' disabled>Select</option>
                      <option v-for="groupObj in getGroupListValue" v-bind:key="groupObj.GroupId" v-bind:value="groupObj">{{ groupObj.GroupName }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 padding-right-0Px text-align-right">
                  <div class="form-group margin-bottom-0Perc" v-if="getSelectedGroupObj !== -1 && associatedCohortList.length > 0">
                    <div class="text-decoration-underline text-color-blue cursor-pointer" @click="performClickOperation($event, showViewGroupMeditationOption ? 'view_meditation' : 'set_meditation')">
                      {{ showViewGroupMeditationOption ? 'View Meditations' : 'Add Meditations' }}
                    </div>
                    </div>
                </div>
                <div class="col-md-2 col-lg-2 text-align-left">
                  <div class="form-group margin-bottom-0Perc" v-if="getSelectedGroupObj !== -1 && showViewGroupReflectionOption && associatedCohortList.length > 0">
                    <div class="text-decoration-underline text-color-blue cursor-pointer" @click="performClickOperation($event, 'view_reflection')">
                      View Reflections
                    </div>
                    </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc" v-if="currSelectedGroupObj !== -1 && associatedCohortList.length > 0 && showViewGroupReflectionOption && showViewGroupMeditationOption">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Cohort:
                </div>
                <div class="col-md-4 col-lg-4 text-align-left">
                  <div class="form-group margin-bottom-0Perc">
                    <select class="form-control" v-model="getSelectedCohortObj" :disabled="disableCohortDropDown">
                      <option value='-1' disabled>Select</option>
                      <option v-for="cohortObj in getCohortListValue" v-bind:key="cohortObj.CohortId" v-bind:value="cohortObj">{{ cohortObj.CohortName }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-5 col-lg-5"></div>
              </div>
              <div class="row margin-bottom-2Perc" v-if="currSelectedGroupObj !== -1 && associatedCohortList.length > 0 && currSelectedCohortObj !== -1 && showViewGroupReflectionOption && showViewGroupMeditationOption">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  LEAPS Goal(s):
                </div>
                <div class="col-md-8 col-lg-8">
                  <div class="form-group">
                    <div class="text-align-left">
                      <!-- <input type="checkbox" v-model="selectAllSelectedValue" >&nbsp;&nbsp;&nbsp; Select All -->
                    </div>
                    <div class="text-align-left" v-for="(leapsChallengeObj, index) in leapsChallengesListValue" :key="index + leapsChallengeObj.ChallengeLibraryId">
                      <!-- <input type="checkbox" v-model="associatedCohortChallengeArrValue" :value="leapsChallengeObj.ChallengeLibraryId"> &nbsp;&nbsp;&nbsp; {{(index + 1)}}. {{leapsChallengeObj.ChallengeTitle}}-->
                      {{(index + 1)}}. {{leapsChallengeObj.ChallengeTitle}}   
                      <div class="margin-left-4Perc text-color-orange" v-for="(leapsAttachedActionObj, actionIndex) in JSON.parse(leapsChallengeObj.ListOfActions)" :key="actionIndex + leapsAttachedActionObj.ActionLibraryId + leapsChallengeObj.ChallengeLibraryId">
                        <input type="checkbox" v-model="leapsAttachedActionObj.IsChecked" @click="performUserClickAction($event, 'clicked_action', leapsChallengeObj, leapsAttachedActionObj)">&nbsp;&nbsp;&nbsp; {{leapsAttachedActionObj.ActionName}}
                      </div>

                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <!-- ToDo: Track this -->
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="associateGroupLeapsChallenges" :disabled="currSelectedCohortObj === undefined || currSelectedCohortObj === 'undefined' || currSelectedCohortObj === null || currSelectedCohortObj === 'null' || currSelectedCohortObj === -1 || currSelectedCohortObj === ''">Associate</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="redirectToAssociateMeditationOrReflection"></confirmation-alert>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
      <loader></loader>
 </div>
 </div>
</template>

<script>
import { constants } from '@/utils/constants'
import { groupService } from '@/server-util/group-service'
import { cohortService } from '@/server-util/cohort-service'
import { groupCourseService } from '@/server-util/group-course-service'
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
import { leapsChallengesService } from '@/server-util/leaps-challenges-service'
import { forEach, findIndex, filter, find } from 'lodash'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
export default {
  created: function () {
    this.setDefaultValues()
    this.getGroupList()
    this.getLeapsChallengesList()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      currSelectedGroupObj: -1,
      associatedCohortChallengeActionArr: [],
      associatedCohortChallengeArr: [],
      associatedCohortActionArr: [],
      associatedCohortList: [],
      isLeapsChallengeAssociatedSuccessfully: false,
      createObj: null,
      currSelectedCohortObj: -1,
      selectAllSelected: false,
      disableCohortDropDown: false,
      disableGroupDropDown: false,
      showViewGroupReflectionOption: false,
      showViewGroupMeditationOption: false,
      showConfirmationBox: false,
      prefixString: '',
      postString: ''
    }
  },
  name: 'associate-cohort-leaps-challenge',
  methods: {
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of confrimation overlay
      this.showConfirmationBox = value
    },
    hasLeapsMeditationAndReflectionAttached: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '' &&
        this.currSelectedGroupObj !== undefined && this.currSelectedGroupObj !== null && this.currSelectedGroupObj !== '' && this.currSelectedGroupObj !== -1
      ) {
        this.$store.state.isLoading = true
        groupCourseService
          .listAssociatedGroupMeditationAndReflectionList(
            storeObj.state.access_token,
            this.currSelectedGroupObj.GroupId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              if (responseObj.data.MeditationList.length === 0) {
                this.showViewGroupMeditationOption = false
                this.showConfirmationBox = true
                this.prefixString = 'No Meditations found for \'' + this.currSelectedGroupObj.GroupName + '\' group. '
                this.postString = 'Do you want to associte it now?'
              } else {
                this.showViewGroupMeditationOption = true
                this.showConfirmationBox = false
              }
              this.showViewGroupReflectionOption = true
              if (responseObj.data.ReflectionQuestionList.length === 0) {
                if (!this.showConfirmationBox) {
                  this.showConfirmationBox = true
                  this.prefixString = 'No Reflections found for \'' + this.currSelectedGroupObj.GroupName + '\' group. '
                  this.postString = 'Do you want to associte it now?'
                }
              } else {
                this.showConfirmationBox = false
              }
              this.$store.state.isLoading = false
            } else {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'GroupId is NULL hence declined Loading ASSOCIATED GROUP MEDITATION And REFLECTION List.'
        )
      }
    },
    performClickOperation: function (event, operationName) {
      this.$store.state.hightLightOptionExplictly = false
      localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Users)
      localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.Groups)
      switch (operationName) {
        case 'view_reflection':
          let routeData = this.$router.resolve({name: 'groups', query: {openReflectionPopup: 'true', groupId: this.currSelectedGroupObj.GroupId}})
          window.open(routeData.href, '_blank')
          // this.$router.push('/groups?openReflectionPopup=' + true + '&groupId=' + this.currSelectedGroupObj.GroupId)
          break
        case 'view_meditation':
          routeData = this.$router.resolve({name: 'groups', query: {openMeditationPopup: 'true', groupId: this.currSelectedGroupObj.GroupId}})
          window.open(routeData.href, '_blank')
          // this.$router.push('/groups?openMeditationPopup=' + true + '&groupId=' + this.currSelectedGroupObj.GroupId)
          break
        case 'set_meditation':
          routeData = this.$router.resolve({name: 'groups', query: {setupMeditationPopup: 'true', groupId: this.currSelectedGroupObj.GroupId}})
          window.open(routeData.href, '_blank')
          // this.$router.push('/groups?setupMeditationPopup=' + true + '&groupId=' + this.currSelectedGroupObj.GroupId)
          break
        default:
          break
      }
    },
    performUserClickAction: function (event, operationName, leapsChallengeObj, leapsAttachedActionObj) {
      switch (operationName) {
        case 'clicked_action':
          const foundChallengeIndex = findIndex(this.$store.state.leapsChallengesList, (challengeObj) => {
            return leapsChallengeObj.ChallengeLibraryId === challengeObj.ChallengeLibraryId
          })
          if (foundChallengeIndex > -1) {
            const associatedActions = JSON.parse(this.$store.state.leapsChallengesList[foundChallengeIndex].ListOfActions)
            if (associatedActions.length > 0) {
              const foundActionIndex = findIndex(associatedActions, (actionObj) => {
                return leapsAttachedActionObj.ActionLibraryId === actionObj.ActionLibraryId
              })
              if (foundActionIndex > -1) {
                associatedActions[foundActionIndex].IsChecked = !associatedActions[foundActionIndex].IsChecked
                this.$store.state.leapsChallengesList[foundChallengeIndex].ListOfActions = JSON.stringify(associatedActions)
              }
            }
          }
          break
      }
    },
    setDefaultValues: function () {
      window.onfocus = () => {
        this.hasLeapsMeditationAndReflectionAttached()
      }
    },
    closeCurrentOverlay: function () {
      var objToReturn = {
        operationName: 'close_overlay'
      }
      this.$emit('updateValues', objToReturn)
    },
    resetValuesToDefault: function () {
      this.associatedCohortChallengeArr = []
      this.currSelectedGroupObj = -1
      this.currSelectedCohortObj = -1
    },
    getSelectedChallengeAction: function () {
      var arrToReturn = []
      forEach(this.$store.state.leapsChallengesList, (challengeObj) => {
        const selectedActionCount = filter(JSON.parse(challengeObj.ListOfActions), (actionObj) => {
          return actionObj.IsChecked
        }).length
        if (selectedActionCount > 0) {
          var objToPush = {
            ChallengeID: challengeObj.ChallengeLibraryId,
            ActionIds: []
          }
          forEach(JSON.parse(challengeObj.ListOfActions), (actionObj) => {
            if (actionObj.IsChecked) {
              objToPush.ActionIds.push(actionObj.ActionLibraryId)
            }
          })
          objToPush.ActionIds = JSON.stringify(objToPush.ActionIds)
          arrToReturn.push(objToPush)
        }
      })
      return arrToReturn
    },
    associateGroupLeapsChallenges: function () {
      var storeObj = this.$store
      var objToPost = {
        CohortID: this.currSelectedCohortObj.CohortId,
        ChallengeActions: this.getSelectedChallengeAction()
      }
      console.log('Obj To Post: ' + JSON.stringify(objToPost))
      if (this.validateRequiredFieldBeforeSubmit(objToPost.ChallengeActions)) {
        if (
          storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
        ) {
          this.$store.state.isLoading = true
          cohortService
            .associateCohortWithLeapsChallenges(
              storeObj.state.access_token,
              objToPost
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                this.isLeapsChallengeAssociatedSuccessfully = true
                this.showAlertDialog = true
                this.errorMsg = '\'' + this.currSelectedCohortObj.CohortName + '\' successfully associated with selected goals.'
                this.$store.state.isLoading = false
              } else {
                // AK: Hide Spinner
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Access Token is NULL hence declined ASSCOIATE GROUP WITH LEAPS GOAL.'
          )
        }
      }
    },
    associateGroupCourseCohortList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '' &&
        this.currSelectedGroupObj !== undefined && this.currSelectedGroupObj !== 'undefined' && this.currSelectedGroupObj !== null && this.currSelectedGroupObj !== 'null' && this.currSelectedGroupObj !== '' && this.currSelectedGroupObj !== -1
      ) {
        this.$store.state.isLoading = true
        groupCourseService
          .listGroupCourseCohortForMeetingMentor(
            storeObj.state.access_token,
            this.currSelectedGroupObj.GroupId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.associatedCohortList = responseObj.data
              if (this.associatedCohortList.length === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No cohort(s) found in "' + this.currSelectedGroupObj.GroupName + '" group.'
                this.associatedCohortList = []
                this.currSelectedCohortObj = -1
                this.showViewGroupMeditationOption = false
                this.showViewGroupReflectionOption = false
              } else {
                const cohortId = this.$route.query.cohortId
                if (cohortId !== undefined && cohortId !== 'undefined' && cohortId !== null && cohortId !== 'null' && cohortId !== '') {
                  this.currSelectedCohortObj = find(this.getCohortListValue, (obj) => {
                    return obj.CohortId === cohortId
                  })
                  if (this.currSelectedCohortObj === undefined || this.currSelectedCohortObj === 'undefined' || this.currSelectedCohortObj === null || this.currSelectedCohortObj === 'null' || this.currSelectedCohortObj === '') {
                    this.currSelectedCohortObj = -1
                  } else {
                    this.disableCohortDropDown = true
                  }
                }
              }
              this.$store.state.isLoading = false
              this.hasLeapsMeditationAndReflectionAttached()
            } else {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'GroupId is NULL hence declined Loading GROUP COURSE COHORT List.'
        )
      }
    },
    getLeapsChallengesList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        this.$store.state.isLoading = true
        leapsChallengesService
          .getLeapsChallengeList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.$store.state.leapsChallengesList = responseObj.data
              this.$store.state.isLoading = false
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING LEAPS CHALLEGNE LIST'
        )
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      if (this.isLeapsChallengeAssociatedSuccessfully) {
        this.closeCurrentOverlay()
        this.isLeapsChallengeAssociatedSuccessfully = false
        this.resetValuesToDefault()
      }
    },
    getGroupList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        // AK: Check weather Grouplist is already present or not?
        if (storeObj.state.groupList.length === 0) {
          this.$store.state.isLoading = true
        }
        groupService
          .listGroups(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupList = responseObj.data
              const groupId = this.$route.query.groupId
              if (groupId !== undefined && groupId !== 'undefined' && groupId !== null && groupId !== 'null' && groupId !== '') {
                this.getSelectedGroupObj = find(this.getGroupListValue, (obj) => {
                  return obj.GroupId === groupId
                })
                if (this.getSelectedGroupObj === undefined || this.getSelectedGroupObj === 'undefined' || this.getSelectedGroupObj === null || this.getSelectedGroupObj === 'null' || this.getSelectedGroupObj === '') {
                  this.getSelectedGroupObj = -1
                } else {
                  this.disableGroupDropDown = true
                }
              }
              this.$store.state.isLoading = false
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING GROUP LIST'
        )
      }
    },
    isJson: function (strToCheck) {
      var valueToReturn = false
      strToCheck = (typeof strToCheck !== 'string') ? JSON.stringify(strToCheck) : strToCheck
      try {
        strToCheck = JSON.parse(strToCheck)
      } catch (e) {
        valueToReturn = false
      }
      if (typeof strToCheck === 'object' && strToCheck !== null) {
        valueToReturn = true
      }
      return valueToReturn
    },
    validateRequiredFieldBeforeSubmit: function (objToPost) {
      if (this.currSelectedGroupObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group.'
        return false
      } else if (this.currSelectedCohortObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a cohort.'
        return false
      } else if (objToPost.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select atleast one LEAPS Goal to associate with \'' + this.currSelectedCohortObj.CohortName + '\' cohort.'
        return false
      }
      return true
    },
    redirectToAssociateMeditationOrReflection: function (value) {
      // AK: If user migrate from previous select question type to new, reset all correct option data
      if (value) {
        const strToCompare = 'No Reflections found for \'' + this.currSelectedGroupObj.GroupName + '\' group. '
        if (this.prefixString === strToCompare) {
          this.performClickOperation(null, 'view_reflection')
        } else {
          this.performClickOperation(null, 'set_meditation')
        }
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'confirmation-alert': ConfirmationOverlay
  },
  computed: {
    getSelectedGroupObj: {
      get: function () {
        return this.currSelectedGroupObj
      },
      set: function (newValue) {
        console.log('newValueL: ' + JSON.stringify(newValue))
        this.currSelectedGroupObj = newValue
        this.currSelectedCohortObj = -1
        this.showViewGroupMeditationOption = false
        this.showViewGroupReflectionOption = false
        if (newValue !== -1) {
          this.associateGroupCourseCohortList()
        }
      }
    },
    getSelectedCohortObj: {
      get: function () {
        return this.currSelectedCohortObj
      },
      set: function (newValue) {
        this.currSelectedCohortObj = newValue
      }
    },
    getGroupListValue: {
      get: function () {
        return this.$store.state.groupList
      }
    },
    getCohortListValue: {
      get: function () {
        return this.associatedCohortList
      }
    },
    leapsChallengesListValue: {
      get: function () {
        return this.$store.state.leapsChallengesList
      },
      set: function (newValue) {
        this.$store.state.leapsChallengesList = newValue
      }
    },
    selectAllSelectedValue: {
      get: function () {
        return this.selectAllSelected
      },
      set: function (newValue) {
        this.selectAllSelected = newValue
        this.associatedCohortChallengeArr = []
        this.associatedCohortActionArr = []
        if (newValue) {
          forEach(this.leapsChallengesListValue, (obj) => {
            this.associatedCohortChallengeArr.push(obj.ChallengeLibraryId)
            const listOfActions = JSON.parse(obj.ListOfActions)
            forEach(listOfActions, (actionObj) => {
              this.associatedCohortActionArr.push(actionObj.ActionLibraryId)
            })
          })
        }
      }
    },
    associatedCohortChallengeArrValue: {
      get: function () {
        return this.associatedCohortChallengeArr
      },
      set: function (newValue) {
        this.associatedCohortChallengeArr = newValue
        this.selectAllSelected = (this.associatedCohortChallengeArr.length === this.leapsChallengesListValue.length)
      }
    },
    associatedCohortActionArrValue: {
      get: function () {
        return this.associatedCohortActionArr
      },
      set: function (newValue) {
        this.associatedCohortActionArr = newValue
      }
    }
  }
}
</script>

<style scoped>
.text-decoration-underline {
  text-decoration: underline;
}
.text-color-blue {
  color: blue;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.text-color-orange {
  color: #f39c12;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 5%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-left-0Px {
  padding-left: 0px !important;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
</style>





// WEBPACK FOOTER //
// src/components/group/AssociateCohortLeapsChallengeOverlay.vue